<template>
    <div class="base-login" :class="{ 'login-sp': $store.state.screen == 1 }" v-show="isCloudPlay==0">
        <div class="header">
            <div class="item" :class="{ isitem: activeNav == index }" v-for="(item, index) in navList" :key="index"
                @click="onNav(index)">
                <span>{{ item }}</span>
                <div class="line" v-show="activeNav == index"></div>
            </div>
        </div>
        <div class="content">
            <transition name="component-fade" mode="out-in">
                <!-- 安卓 -->
                <div v-if="config.system == 1">
                    <!-- <div v-show="activeNav == 0">
                        <img class="logo" src="~images/logo_max.png" />
                        <div class="btn-login" @click="onOnekey">焕游游戏APP一键登录</div>
                    </div> -->
                    <BaseLoginPhone @childPwd='childPwd' v-show="activeNav == 0" />
                    <BaseLoginPwd @childPhone='childPhone' v-show="activeNav == 1" />
                </div>
                <!-- ios -->
                <div v-else>
                    <BaseLoginPhone @childPwd='childPwd' v-show="activeNav == 0" />
                    <BaseLoginPwd @childPhone='childPhone' v-show="activeNav == 1" />
                </div>
            </transition>
        </div>
    </div>
</template>

<script>
import BaseLoginPhone from './BaseLoginPhone'
import BaseLoginPwd from './BaseLoginPwd'

export default {
    name: 'BaseLogin',
    components: {
        BaseLoginPhone,
        BaseLoginPwd
    },
    data() {
        return {
            navList: [],
            activeNav: 0,
            isCloudPlay:1
        }
    },
    methods: {
        onNav(index) {
            this.activeNav = index
        },
        childPwd(event) {
            this.activeNav = event
        },
        childPhone(event) {
            this.activeNav = event
        },
        // app一键登录
        onOnekey() {
            if (this.config.system == 1) {
                let loginData = JSON.parse(sessionStorage.getItem('loginData'))
                if (loginData.isHasBox == 1) {
                    let userData = JSON.parse(window.Android.boxLogin())
                    if (userData.account) {
                        this.$router.push('/base-quick')
                    } else {
                        window.Android.openBox()
                    }
                } else {
                    window.Android.openBox()
                }
            }
        },
        // 获取账号，密码
        updateAccount() {
            if (this.config.system == 1) {
                let userData = JSON.parse(window.Android.boxLogin())
                if (userData.account) {
                    this.$router.push('/base-quick')
                }
            }
        }
    },
    created() {
        if (this.config.system == 1) {
            // this.navList = ['快捷登录', '手机登录', '密码登录']
            this.navList = ['手机登录', '密码登录']
        } else {
            this.navList = ['手机登录', '密码登录']
            if (localStorage.getItem('iosUser')) {
                this.activeNav = 1
            }
        }

        // 初始化时从url获取参数
        let obj = {
            uid: this.$route.query.uid,
            cuid: this.$route.query.cuid,
            appid: this.$route.query.appId,
            appkey: this.$route.query.appKey,
            channel: this.$route.query.channel,
            system: this.$route.query.system,
            coinEnable: this.$route.query.coinEnable,
            // isHasBox 0、未安装app 1、已安装app
            isHasBox: this.$route.query.isHasBox,
            // 厂商
            maker: this.$route.query.maker,
            // 手机类型
            mobile_model: this.$route.query.mobileModel,
            // 手机设备号
            machine_code: this.$route.query.machineCode,
            // 设备ID
            machine_id: this.$route.query.androidId,
            // 系统版本
            system_version: this.$route.query.versionName,
            // 广告图片跳转链接
            getAdLinkUrl: this.$route.query.adLinkUrl,
            // 广告图片地址
            getAdImageUrl: this.$route.query.adImageUrl,
            // 是否显示广告图片
            // isDisplayAd: allUrlParams.isDisplayAd,
            // 是否开启注册
            isRegisterEnabled: this.$route.query.registerEnabled,
            // 是否开启实名认证
            isNameAuthEnabled: this.$route.query.nameAuthEnabled,
            // 是否显示平台币和平台币支付
            isPlatformMoneyEnabled: this.$route.query.platformMoneyEnabled,
            // 是否开启绑定手机
            isBindMobileEnabled: this.$route.query.bindMobileEnabled,
            // 折扣
            discount: this.$route.query.discount
        }
        // 进入登录页面时存储url参数
        if (this.$route.query.uid || this.$route.query.appId) {
            sessionStorage.setItem('loginData', JSON.stringify(obj))
        }
    //    isCloudPlay为1,云玩进入自动登录
        if (this.$route.query.isCloudPlay == 1) {
            this.isCloudPlay = this.$route.query.isCloudPlay
            let userinfo = {
                data: {
                    uid: this.$route.query.uid,
                    is_auth: this.$route.query.isAuth,
                    token: this.$route.query.token,
                    isCloudPlay:this.isCloudPlay
                }
            }
            sessionStorage.setItem('userData', JSON.stringify(userinfo))
            this.$router.push('/base-trumpet-select')

        }else{
            this.isCloudPlay = 0
        }

    },
    mounted() {
        // 暴露方法给安卓调用
        window.updateAccount = this.updateAccount
    }
}
</script>

<style lang="scss" scoped>
$color: #FF6C22; // 主体颜色

// 横屏css
.base-login {
    width: 864px;
    min-height: 888px;
    overflow: hidden;
    border-radius: 18px;
    background: rgba(0, 0, 0, 0.8);
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    .header {
        width: 100%;
        height: 132px;
        font-size: 36px;
        border-radius: 18px 18px 0 0;
        background: rgba($color, 0.8);
        display: flex;
        justify-content: space-around;
        align-items: center;

        .item {
            height: 100%;
            font-size: 36px;
            transition: all 0.1s;
            display: flex;
            align-items: center;
            position: relative;

            .line {
                width: 30px;
                height: 10px;
                background: #fff;
                position: absolute;
                bottom: 0;
                left: 40%;
                -moz-transform: skewX(-45deg);
                -ms-transform: skewX(-45deg);
                -webkit-transform: skewX(-45deg);
                transform: skewX(-45deg);
            }
        }

        .isitem {
            font-size: 45px;
        }
    }

    .content {
        min-height: 756px;
        padding: 0 60px;
        overflow: hidden;

        .logo {
            width: 180px;
            height: 180px;
            margin: 120px auto 0;
            display: block;
        }

        .btn-login {
            height: 120px;
            font-size: 39px;
            border-radius: 18px;
            background: $color;
            margin-top: 120px;
            display: flex;
            align-items: center;
            justify-content: center;
        }
    }
}

// 竖屏css
.login-sp {
    width: 1570px;
    min-height: 1614px;
    border-radius: 32px;

    .header {
        height: 240px;
        font-size: 65px;
        border-radius: 32px 32px 0 0;

        .item {
            font-size: 65px;

            .line {
                width: 54px;
                height: 18px;
            }
        }

        .isitem {
            font-size: 81px;
        }
    }

    .content {
        min-height: 1374px;
        padding: 0 90px;

        .logo {
            width: 327px;
            height: 327px;
            margin: 200px auto 0;
        }

        .btn-login {
            height: 200px;
            font-size: 70px;
            border-radius: 32px;
            margin-top: 200px;
        }
    }
}
</style>